/**
 * WEB-2054 — ОБЩАЯ ОБЁРТКА блока для всех неядерных кусков рендерера.
 *
 * Это тот же порядок обёрток, что стоял в хвосте `PublicBlockRendererExtended`
 * до разреза, слово в слово: шрифт → подложка элемента → расстояние →
 * фон блока → выравнивание. Вынесен он ровно затем, чтобы разрез не размножил
 * этот порядок по кускам: обёртки задают отступы и поверхность КАЖДОГО блока, и
 * разошедшиеся копии означали бы «в одной семье блоков отступ есть, в другой
 * нет» — расхождение, которого посетитель не объяснит, а автор не найдёт.
 *
 * Пояснения к порядку (перенесены вместе с кодом, они не косметика):
 *  - WEB-1062: подложка блока — общая обёртка на выходе, единая для ЛЮБОГО вида;
 *  - WEB-1711: блок, который сам красит свою поверхность значением поля, заливку
 *    обёртке не отдаёт — иначе переменная поддерева покрасила бы вложенную
 *    кнопку;
 *  - WEB-1708: обёртка расстояния — СНАРУЖИ обёртки подложки. Внутри неё
 *    авторские поля заперты в коробке с внутренним отступом: наружу они не
 *    выходят и зазора до соседних блоков не создают;
 *  - WEB-1695: положение блока по горизонтали — общая обёртка ВНУТРИ подложки:
 *    плашка остаётся во всю ширину, а содержимое едет к нужному краю. Блок без
 *    заданного значения обёртки не получает вовсе (старая воронка не сдвигается).
 */
import React from 'react';
import type { EditorBlock } from '@/store/editorSlice';
import { withBlockFont } from './blockFont';
import { withBlockSpacing } from './blockSpacing';
import { withBlockAlign } from './blockAlign';
import { withBlockBackground } from './blockBackgroundStyle';
import {
  withBlockInnerSurface,
  innerSurfaceFieldsOf,
} from './blockInnerSurface';

export function withExtendedBlockShell(
  block: EditorBlock,
  rendered: React.ReactElement | null,
  followsExplicitSpacing?: boolean,
): React.ReactElement | null {
  return withBlockFont(
    block.fontId,
    withBlockInnerSurface(
      innerSurfaceFieldsOf(block),
      withBlockSpacing(
        block,
        withBlockBackground(
          block.background,
          withBlockAlign(block, rendered),
          block,
        ),
        { followsExplicitSpacing },
      ),
    ),
  );
}
